<template>
  <div>
    <LsModal title="Long Grass Policy" track-id="long_grass_policy_modal">
      <template #body>
        <div>
          <p v-for="(paragraph, index) in longGrassPolicy" :key="index">{{ paragraph }}</p>
        </div>
      </template>
    </LsModal>
  </div>
</template>

<script>
import { LsModal } from '@/components/common';
import { lsLongGrassHelpers } from '@/helpers';

export default {
  name: 'LongGrassPolicyModal',
  components: {
    LsModal,
  },
  computed: {
    longGrassPolicy() {
      return lsLongGrassHelpers.getLongGrassPolicy();
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  padding: 10px 0;
}
</style>
